import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CTMapDashboardBridgeService {
  private _attributeResults$ = new BehaviorSubject<any>(null);
  attributeResults$ = this._attributeResults$.asObservable();

  setAttributeResults(value: any) {
    this._attributeResults$.next(value);
  }
}
